import { render } from "./ViewLeitura.vue?vue&type=template&id=108582c2&scoped=true"
import script from "./ViewLeitura.vue?vue&type=script&lang=js"
export * from "./ViewLeitura.vue?vue&type=script&lang=js"

import "./ViewLeitura.vue?vue&type=style&index=0&id=108582c2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108582c2"]])

export default __exports__